import { render, staticRenderFns } from "./dividendecreateForm.vue?vue&type=template&id=010d6180&"
import script from "./dividendecreateForm.vue?vue&type=script&lang=js&"
export * from "./dividendecreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports